import * as React from "react";
import {Button, Modal} from "react-bootstrap";
import {FormattedMessage, InjectedIntlProps, injectIntl} from "react-intl";
import {WithApi, WithApiProperties} from "../common/util/WithApi";
import {CustomPropertyDetail, readOnlyCustomProperties} from "./model";

export interface CustomPropertiesDialogOwnProps {
  onClose: () => void;
  onUpdate: (customProperties: CustomPropertyDetail[]) => void;
  getSelectedCustomProperties: () => CustomPropertyDetail[];
  getCurrentCustomProperties: () => CustomPropertyDetail[];
}

type CustomPropertiesDialogProps = CustomPropertiesDialogOwnProps & InjectedIntlProps & WithApiProperties;

interface CustomPropertiesDialogState {
  filter: string,
  customPropertyDetails: CustomPropertyDetail[],
  update: boolean,
}

class CustomPropertiesDialogComponent extends React.Component<CustomPropertiesDialogProps, CustomPropertiesDialogState> {
  constructor(props: CustomPropertiesDialogProps) {
    super(props);

    this.state = {
      filter: null,
      customPropertyDetails: null,
      update: true,
    };
  }

  componentDidMount() {
    const {api} = this.props;
    api.getCustomProperties().then((r) => {
      const customPropertyDetails = r?.customProperties.sort((a, b) => {
        if (a.displayName > b.displayName) {
          return 1
        } else if (b.displayName > a.displayName) {
          return -1
        } else {
          return 0
        }
      });
      this.setState({customPropertyDetails})
    });
  }

  filterChanged = (event) => {
    const {value} = event.target;
    this.setState({filter: value});
  }

  renderSearch = () => {
    setTimeout(() => {
      document.getElementById("customPropertySearch").focus()
    }, 50);
    return <div>
      <FormattedMessage id="studio.ui.custom-properties-dialog.search" defaultMessage="Search:"/>
      <input id="customPropertySearch" type={"text"} name="searchFilter" onChange={this.filterChanged}/>
    </div>
  }

  toggleProperty = (event) => {
    const {customPropertyDetails} = this.state;
    const selectedCustomProperties = this.props.getSelectedCustomProperties();
    const newSelectedCustomProperties = selectedCustomProperties;
    const {checked} = event.target;
    const {name} = event.target;
    const customPropertyChanged = customPropertyDetails.find(property => property.name === name);
    if (!customPropertyChanged) {
      return;
    }
    const selectedCustomPropertyIndex = selectedCustomProperties.indexOf(customPropertyChanged);

    if (checked) {
      if (selectedCustomPropertyIndex === -1) {
        newSelectedCustomProperties.push(customPropertyChanged);
      }
    } else if (selectedCustomPropertyIndex >= 0) {
      newSelectedCustomProperties.splice(selectedCustomPropertyIndex, 1);
    }

    this.props.onUpdate(newSelectedCustomProperties);
    this.setState({update: true});
  }

  renderProperties = (filteredProperties: CustomPropertyDetail[]) => {
    const selectedCustomProperties = this.props.getSelectedCustomProperties();
    const currentCustomProperties = this.props.getCurrentCustomProperties();

    const renderedProperties = [];
    filteredProperties.forEach((property) => {
      if (!readOnlyCustomProperties.includes(property.name) &&
          !currentCustomProperties.find(cp => cp.name === property.name)) {
        renderedProperties.push(<div>
          <input type={"checkbox"}
                 checked={selectedCustomProperties.find(p => p.name === property.name) != null}
                 name={`${property.name}`}
                 onChange={this.toggleProperty}
                 key={`${property.name}-key`}
          />
          {property.displayName}<br/>
        </div>)
      }
    })
    return renderedProperties;
  }

  renderCustomProperties = () => {
    const {customPropertyDetails, filter} = this.state;
    let filteredProperties = customPropertyDetails;
    if (filter && filter !== "") {
      const regex = new RegExp(filter, 'i');
      filteredProperties = customPropertyDetails.filter(({displayName}) => regex.exec(displayName));
    }
    if (filteredProperties) {
      return <div style={{maxHeight: "400px", position: "relative", overflow: "auto"}}>{this.renderProperties(
          filteredProperties)}</div>
    } else {
      return <div><FormattedMessage id="studio.ui.custom-properties-dialog.loading" defaultMessage="Loading ..."/></div>
    }
  }

  render() {
    const {onClose} = this.props;

    return (
        <Modal className="CustomPropertiesDialog" show={true} onHide={onClose} backdrop={"static"} keyboard={false}>
          <Modal.Header closeButton={true}>
            <Modal.Title>
              <FormattedMessage id="studio.custom-properties.dialog.title"
                                defaultMessage="Select Custom Properties"/>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              {this.renderSearch()}
              {this.renderCustomProperties()}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={onClose}>
              <FormattedMessage id="studio.custom-properties.dialog.close-button" defaultMessage="Close"/>
            </Button>
          </Modal.Footer>
        </Modal>
    );
  }
}

export const CustomPropertiesDialog = WithApi(injectIntl(CustomPropertiesDialogComponent));